import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
// components
import {
  SetPositionForm,
  SelectMethodForm,
} from './';

const JobPostFormStyle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'step',
})(({ theme, step }) => ({
  margin: 'auto',
  maxWidth: step === 'method' ? 760 : 1160,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3, 0),
}));

// --------------------------------------------------

export default function InitJobPosting({ jobPost, reload, close }) {
  const [step, setStep] = useState('');

  useEffect(() => {
    if (jobPost?.status) {
      setStep('method');
    } else {
      setStep('position');
    }
  }, [jobPost]);

  const back = () => setStep('position');
  const next = (jobPostId) => {
    reload(jobPostId || jobPost?.id);
  }

  const renderContent = step === 'method' 
    ? <SelectMethodForm jobPost={jobPost} back={back} next={next} close={close} /> 
    : <SetPositionForm jobPost={jobPost} next={next} close={close} />;

  return (
    <JobPostFormStyle step={step}>
      {renderContent}
    </JobPostFormStyle>
  )
}
